import { API_URLS } from "../../constants";
import apiClient from "../../utils/interceptor";

export const getYardsByCompanyId = async (companyId, siteType) => {
    try {
        const response = await apiClient.get(
            `${API_URLS.YARD.GET_YARDS_BY_COMPANY_ID}/${companyId}`,
            { params: siteType ? { site_type: siteType } : {} }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching yards:", error);
        throw error;
    }
};

export const getGatesByYardIds = async (yardIds) => {
    try {
        const response = await apiClient.post(
            API_URLS.GATE.GET_GATES_BY_YARD_IDS,
            { yard_ids: yardIds }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching gates:", error);
        throw error;
    }
};

export const getShippingLinesByYards = async (yardIds) => {
  try {
    const response = await apiClient.post(
      `${API_URLS.SHIPPING_LINES.GET_SHIPPING_LINES_BY_YARDS}`,
      {
        yard_ids: yardIds,
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching shipping lines:", error);
    throw error;
  }
};

export const getReportStats = async ({ yardIds, startDate, endDate }) => {
  try {
    const response = await apiClient.post(
      API_URLS.SCAN.GET_REPORT_STATS,
      {
        yard_ids: yardIds,
        start_date: startDate,
        end_date: endDate
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching report stats:", error);
    throw error;
  }
};

export const getLatestContainerLocation = async ({ containerNumber, companyId }) => {
  try {
    const response = await apiClient.post(
      API_URLS.PUBLIC_REPORT.GET_LATEST_CONTAINER_LOCATION,
      {
        container_number: containerNumber,
        company_id: companyId,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching latest container location:", error);
    throw error;
  }
};

// NEW — Gate Status Overview (Dock Status Overview cards)
export const getGateStatusOverview = async ({ gateIds, startDate, endDate }) => {
  try {
    const response = await apiClient.post(
      API_URLS.SESSION.GET_GATE_STATUS_OVERVIEW,
      {
        gate_ids: gateIds,
        start_date: startDate,
        end_date: endDate,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching gate status overview:", error);
    throw error;
  }
};

// NEW — Warehouse Cargo Summary (Total Cargo / Loaded / Unloaded cards)
export const getWarehouseCargoSummary = async ({ gateIds, startDate, endDate }) => {
  try {
    const response = await apiClient.post(
      API_URLS.SESSION.GET_WAREHOUSE_CARGO_SUMMARY,
      {
        gate_ids: gateIds,
        start_date: startDate,
        end_date: endDate,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching warehouse cargo summary:", error);
    throw error;
  }
};

// NEW — Hourly Throughput heatmap
export const getHourlyThroughput = async ({ gateIds, startDate, endDate }) => {
  try {
    const response = await apiClient.post(
      API_URLS.SESSION.GET_HOURLY_THROUGHPUT,
      {
        gate_ids: gateIds,
        start_date: startDate,
        end_date: endDate,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching hourly throughput:", error);
    throw error;
  }
};

export const getLatestSurveyDate = async (yardIds) => {
  try {
    const response = await apiClient.post(
      API_URLS.SCAN.GET_LATEST_SURVEY_DATE,
      {
        yard_ids: yardIds,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching latest survey date:", error);
    throw error;
  }
};

export const getLivePlantView = async (companyId) => {
  try {
    const response = await apiClient.get(`${API_URLS.TAG_SCAN.GET_LIVE_PLANT_VIEW}/${companyId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching live plant view:", error);
    throw error;
  }
};

export const getCompanyBays = async (companyId) => {
  try {
    const response = await apiClient.get(`${API_URLS.TAG_SCAN.GET_COMPANY_BAYS}/${companyId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bays:", error);
    throw error;
  }
};

export const getBayVisits = async ({ companyId, startDate, endDate }) => {
  try {
    const response = await apiClient.post(API_URLS.TAG_SCAN.GET_BAY_VISITS, {
      company_id: companyId,
      start_date: startDate,
      end_date: endDate,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching bay visits:", error);
    throw error;
  }
};

export const getTripJourney = async (tripId) => {
  try {
    const response = await apiClient.get(`${API_URLS.TAG_SCAN.GET_TRIP_JOURNEY}/${tripId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching trip journey:", error);
    throw error;
  }
};